import React from "react";
import { constants } from "./constants";

console.log("constants: ", constants);

export const ConstantsContext = React.createContext(constants["campus"]);
